import { Box } from "@material-ui/core";
import { FC, useEffect } from "react";
import { useStyles } from "../styles";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useDispatch } from "react-redux";
import { StationSelect } from "componentsNew/elements/SelectField";
import { getReportsAction, shiftTrackerUpdateFilters } from "actions/shiftTrackerActions";
import { CustomButton } from "componentsNew/buttons/CustomButton";
import FilterList from "@material-ui/icons/FilterList";
import Add from "@material-ui/icons/Add";
import { CustomDrawer } from "componentsNew/drawers/CustomDrawer";
import { ShiftTrackerFiltersDrawerContent } from "componentsNew/drawers/drawerContent/ShiftTrackerFiltersDrawerContent";
import { ModalWindow } from "componentsNew/modals/ModalWindow";
import { CreateShiftModalContent, GiveAccessToOldShiftsModalContent } from "componentsNew/modals/modalContent/ShiftModelContent";

interface PropsType {}

const ShiftReportsListHead: FC<PropsType> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { reportListFilters } = useTypeSelectors((state) => state.dasBoard);

  const {
    pageNumber,
    rowsPerPage,
    station,
    userCreated,
    userUpdated,
    shiftDate,
    shiftDateRange,
    year,
    week,
    month,
    driver,
    fleetNumber,
    fleetVendor,
    fleetSize,
    rabbitSerial,
    dollySerial,
  } = reportListFilters;

  useEffect(() => {
    dispatch(
      getReportsAction(
        pageNumber + 1,
        rowsPerPage,
        station,
        userCreated,
        userUpdated,
        shiftDate,
        shiftDateRange,
        year,
        week,
        month,
        driver,
        fleetNumber,
        fleetVendor,
        fleetSize,
        rabbitSerial,
        dollySerial,
      ),
    );
  }, [
    rowsPerPage,
    pageNumber,
    station,
    dispatch,
    userCreated,
    userUpdated,
    shiftDate,
    shiftDateRange,
    year,
    week,
    month,
    driver,
    fleetNumber,
    fleetVendor,
    fleetSize,
    rabbitSerial,
    dollySerial,
  ]);

  const handleChangeStation = (station: string) => {
    dispatch(shiftTrackerUpdateFilters({ station: station }));
  };

  return (
    <Box className={classes.paper}>
      <Box className={classes.filters}>
        <Box className={classes.filtersLeft}>
          <StationSelect value={station ? station : 0} onChange={handleChangeStation} />
          <CustomDrawer
            customWidth={440}
            buttonType={"custom"}
            drawer_name={`filter-shifts-settings`}
            drawerTitle={`Filter Shifts`}
            customButtonElement={
              <CustomButton
                buttonText={"Filter"}
                onClick={() => null}
                variant="outlined"
                icon={<FilterList />}
              />
            }
          >
            <ShiftTrackerFiltersDrawerContent />
          </CustomDrawer>
        </Box>
        <Box className={classes.filtersRight}>
          <ModalWindow
            modal_name={"access-modal"}
            buttonType={"custom"}
            modalTitle={"Set Access To Old Shifts"}
            customButtonElement={
              <CustomButton
                buttonText={"Access Old Shifts"}
                onClick={() => null}
                variant="outlined"
                mobileScreenSpread
              />
            }
          >
            <GiveAccessToOldShiftsModalContent/>
          </ModalWindow>
          <ModalWindow
            modal_name={"create-shift-modal"}
            buttonType={"custom"}
            modalTitle={"Create Shift"}
            customButtonElement={
              <CustomButton
                buttonText={"Create Shift"}
                onClick={() => null}
                variant="contained"
                icon={<Add />}
                mobileScreenSpread
              />
            }
          >
            <CreateShiftModalContent/>
          </ModalWindow>
        </Box>
      </Box>
    </Box>
  );
};

export default ShiftReportsListHead;
